/**
 * RESPONSIBILITY: the foundations the church names for itself.
 *
 * The number on each is its position, drawn rather than stored: reordering the list must
 * not leave somebody renumbering it by hand.
 */
import { idOf } from '@framework/core';
import type { LeadershipPillarsSection } from '@app/sections';

export function Pillars({ c }: { c: LeadershipPillarsSection }) {
  const pillars = c.pillars ?? [];
  if (pillars.length === 0) return null;

  return (
    <section className="band ldr-pillars-band">
      <div className="wrap">
        <div className="ldr-band-head ldr-band-head--centre">
          {c.eyebrow && <span className="ldr-kicker">{c.eyebrow}</span>}
          <h2 className="ldr-h2">{c.pillarsHeading}</h2>
        </div>

        <div className="grid grid-3 ldr-pillars">
          {pillars.map((p, i) => (
            <div className="ldr-pillar" key={idOf(p) || i}>
              <span className="ldr-pillar__num" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3>{p.title}</h3>
              {p.blurb && <p>{p.blurb}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
